import { Box, useTheme } from '@mui/joy';
import { ChartOptions } from 'chart.js';
import { merge } from 'lodash';
import { useMemo } from 'react';
import { Pie } from 'react-chartjs-2';

import { SkeletonChart } from 'reports/components';

export interface IPieChartDataset {
  backgroundColor: string[];
  borderColor?: string[];
  borderWidth?: number;
  data: number[];
}

export interface IPieChartData {
  datasets: IPieChartDataset[];
  labels: string[];
}

interface IProps {
  data: IPieChartData;
  height?: number | string;
  isLoading?: boolean;
  options?: ChartOptions<'pie'>;
}

export const PieChart = ({ data, height, isLoading, options }: IProps) => {
  const theme = useTheme();

  const textColor = theme.palette.text.primary;

  const defaultOptions: ChartOptions<'pie'> = useMemo(
    () => ({
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: textColor,
          },
          position: 'right',
        },
        tooltip: {
          enabled: true,
        },
      },
      responsive: true,
    }),
    [textColor]
  );

  const mergedOptions = options ? merge({}, defaultOptions, options) : defaultOptions;

  if (isLoading) {
    return <SkeletonChart height={height} />;
  }

  return (
    <Box sx={{ height }}>
      <Pie data={data} options={mergedOptions} />
    </Box>
  );
};
